import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'ADXR',
  version: 1,
  label: 'ADX Rating',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 130,
  inputs: [period('timeperiod', 14)],
  outputs: [line('adx', 'ADX', COLOR.orange), line('adxr', 'ADXR', COLOR.blue)],
  talib: {
    functions: ['ADX', 'ADXR'],
    expr: {
      adx: 'ADX(high, low, close, timeperiod={timeperiod})',
      adxr: 'ADXR(high, low, close, timeperiod={timeperiod})',
    },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => 3 * timeperiod - 2,
}
export default def
